import Vue from 'vue'
import VueRouter from 'vue-router'
import appContent from '@/components/content'

import main from '@/views/home'
import stok from '@/views/stok'
import cari from '@/views/cari'
import caridetay from '@/views/caridetay'
import hareket from '@/views/hareket'


import satis from '@/views/satis'
import satisdetay from '@/views/satisdetay'
import ekstredetay from '@/views/ekstredetay'


import sepet from '@/views/sepet'
import hesap from '@/views/hesap'
//
import login from '@/views/login'
import oturum from '@/views/oturum'
import uretim from '@/views/uretim'
import ziyaret from '@/views/ziyaret'
import tahsilat from '@/views/tahsilat'
import liste from '@/views/liste'
import sonuc from '@/views/sonuc'





Vue.use(VueRouter)
// var tfx = JSON.parse(localStorage.getItem("tfx"))
// let firma = "";
// if (tfx != null) {
//   tfx =
//     firma = tfx.firma.isim
// }
const routes = [
  { path: '/login', component: login },
  { path: "/oturum", name: "OTURUM", component: oturum },
  {
    path: '/',
    component: appContent,
    redirect: '/',
    children: [
      {
        path: "/",
        name: "FİRMA",
        component: main,
      },
      {
        path: '/stok',
        name: 'STOK',
        component: stok
      },
      {
        path: '/cari/hareket',
        name: 'EKSTRE',
        component: hareket
      },
      {
        path: '/ekstredetay',
        name: 'DETAY',
        component: ekstredetay
      },
      {
        path: '/cari',
        name: 'MÜŞTERİ',
        component: cari
      },
      {
        path: '/liste',
        name: 'LİSTE',
        component: liste
      },
      {
        path: '/sonuc',
        name: 'SİPARİŞ',
        component: sonuc
      },
      {
        path: '/caridetay',
        name: 'DASHBOARD',
        component: caridetay
      },
      {
        path: '/satis',
        name: 'SİPARİŞLER',
        component: satis
      },
      {
        path: '/satis/:id',
        name: 'SATIŞ DETAY',
        component: satisdetay
      },
      {
        path: '/cari/ziyaret',
        name: 'ZİYARET',
        component: ziyaret
      },
      {
        path: '/cari/tahsilat',
        name: 'TAHSİLAT',
        component: tahsilat
      },
      {
        path: '/uretim',
        name: 'ÜRETİM',
        component: uretim
      },
      {
        path: '/sepet',
        name: 'SEPET',
        component: sepet
      },
      {
        path: '/hesap',
        name: 'HESABIM',
        component: hesap
      }
    ]
  }
];
export const router = new VueRouter({
  //mode: "history",
  routes
});
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = JSON.parse(localStorage.getItem("tfxm"));
  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
      query: { returnUrl: to.path }
    });
  }
  // if (tfx != "null") {
  //   routes[1].children[1].name = tfx.firma.isim

  // }
  next();
})


// WEBPACK FOOTER //
// ./src/router/index.js